import {
  B_06,
  BANNER_DEFAULTS,
  hideB06Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";
import {
  URL_TYPE_OPTIONS,
  CATEGORY_HOME_LINK_TYPE,
  CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  OTHER_LINK_TYPE,
  CATALOG_HOME_LINK_TYPE,
  EXTERNAL_LINK_TYPE,
} from "@stadium/shared/src/constants/stores/routes";

export const B06_PLASMIC_PROPS = {
  b06Eyebrow: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_06].eyebrow,
    description: "Eyebrow text (B06 only)",
    hidden: hideB06Props,
  },
  b06Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_06].heading,
    description: "Main heading (B06 only)",
    hidden: hideB06Props,
  },
  b06Description: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_06].description,
    description: "Description text (B06 only)",
    hidden: hideB06Props,
  },
  b06PrimaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_06].primaryButtonText,
    description: "Primary button text (B06 only)",
    hidden: hideB06Props,
  },
  b06PrimaryButtonLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    description: "Primary button link type (B06 only)",
    hidden: hideB06Props,
  },
  b06PrimaryButtonOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open primary button in new tab (B06 only)",
    hidden: hideB06Props,
  },
  b06PrimaryButtonOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB06Props(props) ||
      (props.b06PrimaryButtonLinkType !== OTHER_LINK_TYPE &&
        props.b06PrimaryButtonLinkType !== EXTERNAL_LINK_TYPE),
  },
  b06PrimaryButtonCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB06Props(props) ||
      (props.b06PrimaryButtonLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.b06PrimaryButtonLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  b06SecondaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_06].secondaryButtonText,
    description: "Secondary button text (B06 only)",
    hidden: hideB06Props,
  },
  b06SecondaryButtonLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    description: "Secondary button link type (B06 only)",
    hidden: hideB06Props,
  },
  b06SecondaryButtonOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open secondary button in new tab (B06 only)",
    hidden: hideB06Props,
  },
  b06SecondaryButtonOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB06Props(props) ||
      (props.b06SecondaryButtonLinkType !== OTHER_LINK_TYPE &&
        props.b06SecondaryButtonLinkType !== EXTERNAL_LINK_TYPE),
  },
  b06SecondaryButtonCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB06Props(props) ||
      (props.b06SecondaryButtonLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.b06SecondaryButtonLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  b06MobileImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_06].mobileImg,
    description: "Mobile/tablet background image (B06 only)",
    hidden: hideB06Props,
  },
  b06DesktopImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_06].desktopImg,
    description: "Desktop background image (B06 only)",
    hidden: hideB06Props,
  },
  b06ImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_06].imageAlt,
    description: "Image alt text (B06 only)",
    hidden: hideB06Props,
  },
  b06OverlayOpacity: {
    type: "number",
    defaultValue: BANNER_DEFAULTS[B_06].overlayOpacity,
    description: "Overlay opacity (0-1) (B06 only)",
    hidden: hideB06Props,
  },
};
